import * as $ from 'jquery';
import Debouncer from '../lib/Debouncer';

export default class StickyItem {
	private stickCSS: string = 'stick';
	private item: JQuery;
	private parent: JQuery;
	private isActive: boolean;
	private isOversize: boolean;
	private id: string;
	private options: any;

	private drawer: any;

	constructor(item: string, options: any) {
		this.item = $(item);
		this.parent = this.item.parent();
		this.isActive = this.item.length !== 0;
		this.isOversize = false;
		this.id = item;
		this.options = options;

		this.drawer = options.container || this.parent;
	}

	stickTestTop(): boolean {
        /* Tests parentTop vs scrollTop */
		return $(window).scrollTop() > (this.drawer.offset().top - this.options.adjustTop);
    }

	stick(): void {
		/*
		 * stick to bottom when item's bottom is greater than the distance from the top of the window to the bottom of the parent
		 * */

		let windowTop: number 		= $(window).scrollTop();
		let parentBottom: number 	= (this.drawer).offset().top + (this.drawer).outerHeight();
		let itemBottom: number		= (this.options.adjustTop) + (this.item).outerHeight();
		let isStuckBottom: boolean	= (parentBottom - itemBottom) <= windowTop;
        let offsetTop: number 		= isStuckBottom ? parentBottom - (windowTop + (this.item).outerHeight()) : this.options.adjustTop;
        let right                   = (this.stickTestTop())? (document.body.getBoundingClientRect().right - this.parent[0].getBoundingClientRect().right) + 'px' : '';
        let width: number           = (this.options.widthSizer).width();

		this.item.css({
            'width' : width,
            'right' : right,
			'top': offsetTop
		});
	}

	isTallerThanWindow(): boolean {
		return $(window).height() < this.item.outerHeight(true);
	}

	private eventScrollHandler(): void {
		this.item.toggleClass(this.stickCSS, this.stickTestTop());
		this.stick();
	}

	bindEventScroll(): void {
		const eventHandlerCB: EventListener = (event: Event) => {
			this.eventScrollHandler();
		};
		this.eventScrollHandler();
		$(window).on('scroll' + this.id, (new Debouncer(eventHandlerCB)).run);
	}

	private eventResizeHandler(): void {
		let wasOversize: boolean = this.isOversize || false;
		this.isOversize = this.isTallerThanWindow();
		if (this.isOversize) {
			$(window).off('scroll' + this.id);
			this.item.removeClass(this.stickCSS);
			this.item.attr('style', '');
		} else if (wasOversize) {
			this.bindEventScroll();
		}
	}

	private eventResizeHandlerCB = () => {
		this.eventResizeHandler();
	}

	bindEventResize(): void {
		const eventHandlerCB: EventListener = (event: Event) => {
			this.eventResizeHandler();
		};
		this.eventResizeHandler();
		window.addEventListener('resize', eventHandlerCB);
	}

	public bindEvents(): void {
		if (this.isActive) {
			this.isOversize = this.isTallerThanWindow();
			this.bindEventResize();
			this.bindEventScroll();
		}
	}

	public unbindEvents(): void {
		if (this.isActive) {
			window.removeEventListener('resize', this.eventResizeHandlerCB);
			$(window).off('scroll' + this.id);
			this.item.removeClass(this.stickCSS);
			this.item.css({
				'width' : '',
				'right' : '',
				'top': ''
			});			
		}
	}
}
